<template>
  <div v-if="currentEarlyBirdCoupon" class="eb-banner">
    <img class="icon" src="app/assets/images/itinerary/loudspeaker.png" />
    <span>Early bird promo: {{ discount }} off</span>
  </div>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import { currencyFormat } from '@/utils/numberUtils.js'
import { computed } from 'vue'

const {
  data: { currentEarlyBirdCoupon },
} = useItineraryStore()
const discount = computed(() => {
  if (!currentEarlyBirdCoupon) return null
  const { baseCurrency, discountAmountCents, discountPercentage } = currentEarlyBirdCoupon
  return discountPercentage ? `${discountPercentage}%` : currencyFormat(discountAmountCents, baseCurrency, true)
})
</script>

<style lang="scss" scoped>
$overlap: 12px;

.eb-banner {
  z-index: 0;
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  color: $green-400;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-top: calc($overlap * -1);
  padding-top: $overlap;
  padding-bottom: calc($overlap * 2);
  transform: translateY($overlap);
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border: 1px solid $green-200;
  background: $green-50;
}

.icon {
  width: 18px;
}
</style>
